// One line of the "Recompense recomandări" list in the user details dialog, from one entry
// of GET /admin/users/{id}/referral-rewards. Pure (no React) because Jest here cannot import
// the dialog's Radix components — the same reason referralSummary.js exists.

// "1 zi" / "2 zile" / "30 de zile": Romanian takes "de" from 20 up and on round hundreds.
const roCount = (count, one, many) => {
  if (count === 1) return `1 ${one}`;
  const rest = count % 100;
  return count >= 20 && (rest === 0 || rest >= 20) ? `${count} de ${many}` : `${count} ${many}`;
};

export function referralRewardLine(entry, language = 'ro') {
  const ro = language === 'ro';
  if (!entry) return '—';
  const e = entry;
  if (e.status === 'skipped') {
    const reasons = {
      no_subscription_history: ro ? 'nu a avut niciun abonament' : 'never had a subscription',
      type_missing: ro ? 'tipul ultimului abonament nu mai există' : 'the last subscription type no longer exists',
      no_stable_target: ro ? 'abonamentul s-a închis în timpul acordării' : 'the subscription closed while it was being granted',
      error: ro ? 'eroare la acordare' : 'an error while granting',
    };
    // An unknown reason is shown as-is rather than mislabelled as one of the above.
    const why = reasons[e.skip_reason] || e.skip_reason || reasons.no_subscription_history;
    return ro ? `Neacordată — ${why}` : `Not granted — ${why}`;
  }
  const washes = Math.max(0, Number(e.washes_added) || 0);
  const days = Math.max(0, Number(e.days_added) || 0);
  const parts = ro
    ? [`+${roCount(washes, 'spălare', 'spălări')}`, `+${roCount(days, 'zi', 'zile')}`]
    : [`+${washes} ${washes === 1 ? 'wash' : 'washes'}`, `+${days} ${days === 1 ? 'day' : 'days'}`];
  const where = e.mode === 'created'
    ? (ro ? 'abonament nou' : 'new subscription')
    : (ro ? 'pe abonamentul existent' : 'on the existing subscription');
  return `${parts.join(', ')} (${where})`;
}
